import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';

import { forgotPasswordDialogReducerKey } from './ForgotPasswordDialogConstants';
import {
  email as emailSelector,
  isEmailValid as isEmailValidSelector,
  isLoading as isLoadingSelector,
  result as resultSelector,
} from './ForgotPasswordDialogSelectors';
import {
  closeForgotPasswordDialog,
  onEmailSubmit as onEmailSubmitAction,
  setEmail as setEmailAction,
  trackAdobeAnalyticsError,
} from './ForgotPasswordDialogActions';
import forgotPasswordDialogReducer from './ForgotPasswordDialogReducer';
import ForgotPasswordDialog from './ForgotPasswordDialog';

const mapStateToProps = (state) => ({
  email: emailSelector(state),
  isEmailValid: isEmailValidSelector(state),
  isLoading: isLoadingSelector(state),
  result: resultSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setEmail: (email) => dispatch(setEmailAction(email)),
  onEmailSubmit: (email) => dispatch(onEmailSubmitAction(email)),
  closeDialog: () => dispatch(closeForgotPasswordDialog()),
  trackAdobeAnalyticsError: (message, prefix) => trackAdobeAnalyticsError(message, prefix),
});

export default compose(
  withReducer(forgotPasswordDialogReducerKey, forgotPasswordDialogReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(ForgotPasswordDialog);
